import { ReactNode, useState } from 'react';
import { LayoutEditComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutEditComponentListItem';
import React from 'react';
import { useGoToDeleteModal, useGoToEditorView } from '../hooks/useJsonComponentNavigation';
import { JsonComponentSwitchProps } from '../JsonComponentSwitch';
import { Box } from '@withjoy/joykit';

type GrabHandleWrapperProps = JsonComponentSwitchProps & {
  title?: string | ReactNode;
  subTitle?: string | ReactNode;
  icon?: ReactNode;
  disableEdit?: boolean;
};

/**
 * Basic grab handle component
 */
export const SimpleGrabHandle = (props: GrabHandleWrapperProps) => {
  const { title, subTitle, icon, componentData, sortable, disableEdit } = props;
  const [isHover, setIsHover] = useState(false);
  const { goToEditorView } = useGoToEditorView();
  const { goToDeleteModal } = useGoToDeleteModal();

  return (
    <LayoutEditComponentListItem
      title={
        typeof title === 'string' ? (
          <Box
            width="100%"
            className="jodit-list"
            flexDirection="column"
            css={{ ['a']: { 'pointer-events': 'none !important' }, fontWeight: 600 }}
            _groupActive={{ color: 'linkActive' }}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        ) : (
          title
        )
      }
      subTitle={subTitle}
      isDragActive={sortable?.isDragActive ?? false}
      dragItemId={sortable?.dragItemId ?? ''}
      isLastItem={false}
      itemId={componentData.id}
      height={sortable?.itemSize}
      icon={icon || null}
      isHover={isHover}
      setIsHover={setIsHover}
      handleEdit={() => {
        if (!disableEdit) {
          goToEditorView(componentData);
        }
      }}
      handleDelete={() => {
        goToDeleteModal(componentData);
      }}
    />
  );
};
